module.exports = __webpack_public_path__ + "img/classic_3.a6e54435.jpg";